export default "__VITE_ASSET__HkUzClvr__"